module.exports = __webpack_public_path__ + "static/my-dashboard-filters-3b2b527be1f658a40029b3d61491ecff.png";